if (!customElements.get('custom-drawer')) {
    customElements.define('custom-drawer', class CustomDrawer extends HTMLElement {
      constructor() {
        super();
        // Generate a unique ID if none is provided
        if (!this.getAttribute('id')) {
          this.setAttribute('id', `drawer-${Math.random().toString(36).substr(2, 9)}`);
        }
  
        // Get the section ID from data attribute
        this.sectionId = this.dataset.drawerId;
        this.drawerType = this.dataset.drawerType;
        
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        
        // Add click event listener to the entire drawer area
        this.addEventListener('click', (evt) => {
          // Close only if clicking the overlay (background) area
          if (evt.target === this) {
            this.close();
          }
        });
  
        // Move drawer to body when constructed
        this.moveToBody();
      }
      
      connectedCallback() {
        // Add click listener for drawer triggers that match this drawer's type
        const drawerType = this.getAttribute('data-drawer-type');
        const drawerId = this.getAttribute('id');
        
        document.querySelectorAll(`[data-drawer-trigger][data-drawer-content="${drawerType}"]`).forEach(trigger => {
          // Only add event listener if it matches this drawer's section ID
          if (trigger.dataset.sectionId === this.sectionId) {
            trigger.addEventListener('click', (evt) => {
              evt.preventDefault();
              
              // Find the specific drawer by ID and type
              const targetDrawer = document.getElementById(drawerId);
              if (targetDrawer) {
                // Update content if provided in data attribute
                if (trigger.dataset.content) {
                  const contentElement = targetDrawer.querySelector('.drawer-content');
                  if (contentElement) {
                    contentElement.innerHTML = trigger.dataset.content;
                  }
                  
                  // Update header if provided
                  if (trigger.dataset.header) {
                    const headerElement = targetDrawer.querySelector('.drawer-title');
                    if (headerElement) {
                      headerElement.textContent = trigger.dataset.header;
                    }
                  }
                }
                
                this.open();
              }
            });
          }
        });
      }
      
      // New method to move drawer to body
      moveToBody() {
        // Only move if not already at body level
        if (this.parentElement && this.parentElement.tagName !== 'BODY' && !this.parentElement.classList.contains('custom-drawer-container')) {
          // Create container if it doesn't exist
          let container = document.querySelector('body > .custom-drawer-container');
          if (!container) {
            container = document.createElement('div');
            container.classList.add('custom-drawer-container');
            document.body.appendChild(container);
          }
          
          // Check if a drawer with the same ID already exists in the container
          const existingDrawer = container.querySelector(`#${this.getAttribute('id')}`);
          if (existingDrawer) {
            // If a drawer with the same ID exists, don't add this one
            this.remove();
            return;
          }
          
          // Move this drawer to the container
          container.appendChild(this);
        }
      }
  
      open() {
        this.moveToBody();
        
        requestAnimationFrame(() => {
          this.classList.add('animate');
          requestAnimationFrame(() => {
            this.classList.add('active');
          });
        });

        document.body.classList.add('overflow-hidden');
      }
  
      close() {
        this.classList.remove('active');
        this.addEventListener('transitionend', () => {
          this.classList.remove('animate');
        }, { once: true });
        
        document.body.classList.remove('overflow-hidden');
      }
  
      setActiveElement(element) {
        this.activeElement = element;
      }
    });
  }

document.addEventListener('DOMContentLoaded', () => {
  // Clean up duplicate drawers
  const drawerContainer = document.querySelector('.custom-drawer-container');
  if (drawerContainer) {
    const drawerIds = new Set();
    const drawers = drawerContainer.querySelectorAll('custom-drawer');
    
    drawers.forEach(drawer => {
      const id = drawer.getAttribute('id');
      if (drawerIds.has(id)) {
        // This is a duplicate drawer, remove it
        drawer.remove();
      } else {
        drawerIds.add(id);
      }
    });
  }
});